import { Component, OnInit, Type, ViewChild } from "@angular/core";
import { MatCheckbox, MatCheckboxChange } from "@angular/material/checkbox";
import { ICommand } from "../../../modules/records/commands/i-command";
import { IApiService } from "../../../modules/records/models/api/i-api-service";
import {
  ActionCol,
  IActionComponent
} from "../../table-col-configs/action-col";

@Component({
  selector: "app-checkbox",
  templateUrl: "./checkbox.component.html",
  styleUrls: ["./checkbox.component.scss"],
})
export class CheckboxComponent<T extends object>
  implements OnInit, IActionComponent<T>
{
  @ViewChild(MatCheckbox) myCheckBox?: MatCheckbox;
  data: string = "";
  commands: ICommand<T, IApiService<T>>[] = [];
  el!: T;

  ngOnInit(): void {}

  setComponentData(
    el: T,
    colConfig: ActionCol<T, Type<CheckboxComponent<T>>, IApiService<T>>
  ) {
    this.data = colConfig.getElementData(el);
    this.commands = colConfig.commands;
    this.el = el;
  }

  onChange(event: MatCheckboxChange) {
    this.onClick();
  }

  onClick(index = 0) {
    this.commands[index].execute(this.el, this.myCheckBox);
  }
}
